import { createTRPCReact } from '@trpc/react-query';
import type { AppRouter } from '@xeito/api/src/routers/index';

export const trpc = createTRPCReact<AppRouter>();
